/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../../../../components/Container/Container";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";

export default function SchufaScandalInfoSectionWbs() {
  return (
    <Container>
      <Typography variant={"h2"} textAlign={"center"}>
        Hintergründe zur Datenweitergabe
      </Typography>
      <Typography variant={"subtitle2"} textAlign={"center"} marginY={4}>
        Möchtest du noch mehr zu dem Thema erfahren? Der Internet- und Medienrechtsexperte Christian Solmecke erklärt dir die Hintergründe und Auswirkungen der
        Datenweitergabe durch Mobilfunkanbieter an die SCHUFA / CRIF.
      </Typography>
      <Stack direction="row" spacing={2} justifyContent={"center"} marginTop={2}>
        <iframe
          width="853"
          height="480"
          src="https://www.youtube.com/embed/0JIlrIJmpaY?rel=0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </Stack>
    </Container>
  );
}
